import { BooleanValue, NumberValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { requiredNonEmptyString, validatePayload, } from '../../../../utils/validate-payload.js';
export const updateCoreFacetNumberOfValues = createAction('commerce/facets/core/updateNumberOfValues', (payload) => validatePayload(payload, {
    facetId: requiredNonEmptyString,
    numberOfValues: new NumberValue({ required: true, min: 1 }),
}));
export const updateCoreFacetIsFieldExpanded = createAction('commerce/facets/core/updateIsFieldExpanded', (payload) => validatePayload(payload, {
    facetId: requiredNonEmptyString,
    isFieldExpanded: new BooleanValue({ required: true }),
}));
/**
 * Action to clear all core facet values.
 *
 * This is primarily used by the breadcrumb manager to reset all selected facets.
 */
export const clearAllCoreFacets = createAction('commerce/facets/core/clearAll');
export const deleteAllCoreFacets = createAction('commerce/facets/core/deleteAll');
/**
 * Action to deselect all values for a given facet.
 *
 * This is primarily used in facets to clear all selected values at the same time.
 *
 * @param payload - The payload of type {@link DeselectAllValuesInCoreFacetPayload} containing the facet ID to clear.
 */
export const deselectAllValuesInCoreFacet = createAction('commerce/facets/core/deselectAllValues', (payload) => validatePayload(payload, {
    facetId: requiredNonEmptyString,
}));
export const updateCoreFacetFreezeCurrentValues = createAction('commerce/facets/core/updateFreezeCurrentValues', (payload) => validatePayload(payload, {
    facetId: requiredNonEmptyString,
    freezeCurrentValues: new BooleanValue({ required: true }),
}));
export const updateAutoSelectionForAllCoreFacets = createAction('commerce/facets/core/updateAutoSelectionForAll', (payload) => validatePayload(payload, {
    allow: new BooleanValue({ required: true }),
}));
